// @ts-strict-ignore
export const updateMonacoDisabledState = ({ editor, disabled }) => {
  // Monaco does not have a native option for a disabled state; best we can do is make use
  // of their readOnly option, disable the child textarea, and apply our own disabled styling
  if (editor) {
    editor.updateOptions({ readOnly: disabled });

    const textareaElement = editor.getDomNode()?.querySelector("textarea");
    if (textareaElement) {
      textareaElement.disabled = disabled;
    }
  }
};
